<template>
    <div class="custom-form" :class="{ 'custom-form-readonly': readonly }">
        <a-form :form="form" :layout="formLayout">
            <div class="panel" v-for="(panel, index) of panels" :key="index">
                <div class="title" v-if="panel.title">
                    {{ panel.title }}
                </div>
                <div class="rows">
                    <a-row v-for="(fields, index) in panel.fieldGroup" :gutter="panel.gutter" :key="index">
                        <a-col v-show="showField(field)" v-for="field in fields" :key="field.field" :span="field.span">
                            <a-form-item
                                :label="field.label"
                                :label-col="field.labelCol"
                                :wrapper-col="field.wrapperCol"
                            >
                                <component
                                    :is="field.type | fieldType"
                                    :showSearch="field.showSearch"
                                    :allowClear="field.allowClear"
                                    :mode="field.mode"
                                    :filter-option="filterOption"
                                    :show-time="field.showTime"
                                    :disabled="readonly || field.disabled"
                                    :valueFormat="field.valueFormat ?? 'YYYY-MM-DD'"
                                    :options="getOption(field)"
                                    @change="
                                        (...args) => {
                                            changeHandle(field.field, field.type, args);
                                        }
                                    "
                                    style="width: 100%; min-width: 100px"
                                    v-decorator="[
                                        field.field,
                                        {
                                            rules: field.rules
                                        }
                                    ]"
                                    :placeholder="field.placeholder"
                                ></component>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </a-form>
    </div>
</template>

<script>
export default {
    props: ['panels', 'readonly', 'fieldsValue', 'hideFields', 'layout'],
    data() {
        return {
            form: this.$form.createForm(this, { name: 'Form' + Math.random() })
        };
    },

    computed: {
        formLayout() {
            return this.layout || 'horizontal';
        }
    },

    filters: {
        fieldType(t) {
            if (t === 'date') {
                return 'a-date-picker';
            } else if (t === 'number') {
                return 'a-input-number';
            } else if (t === 'select') {
                return 'a-select';
            } else if (t === 'radioGroup') {
                return 'a-radio-group';
            } else if (t === 'checkboxGroup') {
                return 'a-checkbox-group';
            } else if (t === 'textarea') {
                return 'a-textarea';
            } else {
                return 'a-input';
            }
        }
    },

    watch: {
        fieldsValue: {
            handler: function (value) {
                this.form.setFieldsValue(value);
            },
            deep: true
        }
    },

    methods: {
        getOption(field) {
            let items = field.items;
            if (field.category) {
                // todo
            }

            return items;
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },

        showField(f) {
            const field = f.field;
            if (!this.hideFields) {
                return true;
            }

            return !this.hideFields.includes(field);
        },

        changeHandle(field, fieldType, args) {
            if (fieldType === 'select') {
                this.$emit('change', field, args[0]);
            }
        }
    },

    mounted() {}
};
</script>

<style lang="scss" scoped>
.custom-form {
    width: 100%;
    .title {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
        margin-bottom: 10px;
    }

    ::v-deep {
        // .ant-input[disabled] {
        //     border: none;
        //     color: #333333;
        //     background: transparent;
        //     cursor: default;
        // }

        .ant-form-item {
            margin-bottom: 12px;
        }

        // 垂直布局样式调整,
        .ant-form-vertical {
            .ant-row {
                display: flex;
                flex-wrap: wrap;

                .ant-form-item {
                    display: flex;
                    flex-direction: column;
                    padding: 0;

                    .ant-form-item-label {
                        padding-bottom: 0;
                    }
                }
            }
        }
    }
}

.custom-form-readonly {
    ::v-deep {
        .ant-form {
            .ant-row {
                .ant-col {
                    .ant-input {
                        color: rgba(0, 0, 0, 1);
                    }

                    .ant-select {
                        color: rgba(0, 0, 0, 1);
                    }

                    .ant-input-number-input {
                        color: rgba(0, 0, 0, 1);
                    }

                    .ant-radio-disabled .ant-radio-inner:after {
                        background-color: #1890ff;
                    }
                    .ant-radio-disabled+span{
                        color: rgba(0, 0, 0);
                    }
                }
            }
        }
    }
}
</style>
